// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__ZS5Wz__WHx6O","overlay-content":"style_overlay-content__IVFmc__WHx6O","state-tag":"style_state-tag__+59RJ__WHx6O"};